import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";
import PositiveListService from "src/modules/data-protection/apis/PositiveListService";
import { getPositiveListErrorKey } from "../helpers/apiError";
import {
    refreshPositiveListMeasure,
} from "../helpers/cache";
import { resolveSavedControls } from "../helpers/controls";

const sameIds = (controls, controlIds) => {
    const savedIds = (controls || []).map((control) => String(control.id)).sort();
    const requestedIds = (controlIds || []).map((id) => String(id)).sort();

    return savedIds.length === requestedIds.length
        && savedIds.every((id, index) => id === requestedIds[index]);
};

const useReplacePositiveListControls = ({ softwareId, t, onSuccess } = {}) => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: async ({ measureId, payload }) => {
            const service = PositiveListService.getInstance();

            return await service.replaceControls(measureId, payload);
        },
        onSuccess: async (measure, variables) => {
            const measureId = variables.measureId;
            const controls = resolveSavedControls(
                measure,
                variables.selectedControls,
                variables.payload?.control_ids
            );
            const controlIds = variables.payload?.control_ids || [];

            await refreshPositiveListMeasure(queryClient, {
                softwareId,
                measureId,
                patch: Array.isArray(controls) ? { controls } : null,
                confirm: (detail) => sameIds(detail?.controls, controlIds),
            });
            toast(t("Related controls updated."), { type: "success" });

            if (typeof onSuccess === "function") {
                onSuccess();
            }
        },
        onError: (error) => {
            if (process.env.NODE_ENV === "development") {
                console.error(error);
            }

            toast(
                t(getPositiveListErrorKey(error) || "An error occurred while saving controls."),
                { type: "error" }
            );
        },
    });
};

export default useReplacePositiveListControls;
